module.exports = __webpack_public_path__ + "img/success.3171d330.png";